import scrollTo from '../../utils/scrollTo';

export default function() {
  const link = document.querySelector('.page-header__top-middle a');
  if (link && link.href.indexOf('#') > -1) {
    const parts = link.href.split('/');
    const id = parts[parts.length - 1].replace('#', '');
    const target = document.getElementById(id);

    if (target) {
      link.addEventListener('click', e => {
        e.preventDefault();
        scrollTo(target, 600, 'easeInOutCubic');
      });
    }
  }
}
